export * from './routes';
export * from './resCodes';
export { default as URL } from './URL';
export * from './texts';

export const IS_PRODUCTION = true;
